import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { Collections } from "./components/site/Collections";
import { Legacy } from "./components/site/Legacy";
import { Featured } from "./components/site/Featured";
import { Craftsmanship } from "./components/site/Craftsmanship";
import { WhyChoose } from "./components/site/WhyChoose";
import { InstagramSection } from "./components/site/Instagram";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { WhatsAppFab } from "./components/site/WhatsAppFab";
import useReveal from "./lib/useReveal";

function App() {
  useReveal();
  return (
    <div className="App font-body antialiased bg-white text-zinc-950">
      <Header />
      <main>
        <Hero />
        <Collections />
        <Legacy />
        <Featured />
        <Craftsmanship />
        <WhyChoose />
        <InstagramSection />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster
        position="top-center"
        toastOptions={{
          className:
            "!bg-zinc-950 !text-white !border !border-zinc-800 !rounded-none",
        }}
      />
    </div>
  );
}

export default App;
